var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrepIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2507_651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50005 0.808594C9.91967 0.808594 12.6918 3.58069 12.6918 7.00031C12.6918 10.4193 9.91967 13.1908 6.50005 13.1908C3.08043 13.1914 0.30957 10.4193 0.30957 7.00031C0.308951 3.58069 3.08043 0.808594 6.50005 0.808594ZM6.49757 5.91574C6.34586 5.91594 6.19951 5.97185 6.08631 6.07285C5.9731 6.17384 5.90092 6.31289 5.88347 6.46359L5.87914 6.5354L5.88162 9.9414L5.88533 10.0132C5.90263 10.1642 5.97487 10.3036 6.08829 10.4047C6.20171 10.5059 6.34838 10.5618 6.50036 10.5618C6.65234 10.5618 6.799 10.5059 6.91242 10.4047C7.02584 10.3036 7.09808 10.1642 7.11538 10.0132L7.11909 9.94078L7.11662 6.53478L7.11228 6.46236C7.09439 6.31178 7.02185 6.173 6.90843 6.07236C6.79501 5.97172 6.64859 5.91621 6.49695 5.91636L6.49757 5.91574ZM6.50067 3.59493C6.29519 3.59493 6.09813 3.67655 5.95284 3.82184C5.80755 3.96713 5.72593 4.16419 5.72593 4.36966C5.72593 4.57514 5.80755 4.7722 5.95284 4.91749C6.09813 5.06278 6.29519 5.1444 6.50067 5.1444C6.60237 5.14436 6.70306 5.12429 6.797 5.08533C6.89094 5.04638 6.97629 4.9893 7.04818 4.91736C7.12006 4.84542 7.17707 4.76002 7.21595 4.66605C7.25483 4.57208 7.27483 4.47136 7.27478 4.36966C7.27474 4.26797 7.25467 4.16727 7.21572 4.07333C7.17676 3.97938 7.11968 3.89404 7.04774 3.82215C6.9758 3.75027 6.8904 3.69326 6.79643 3.65438C6.70246 3.6155 6.60175 3.59551 6.50005 3.59555L6.50067 3.59493Z",
    fill: "#292929"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2507_651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepIcon);
export default __webpack_public_path__ + "static/media/prepIcon.03805a7d42ff142bc247a6614017ada4.svg";
export { ForwardRef as ReactComponent };